import React from 'react';
import { Camera, Mail, FileText, Shield, AlertCircle } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { Card } from '../components/Card';
import { WarningBanner } from '../components/WarningBanner';
import { SEO } from '../components/SEO';
export function EvidenceSafetyPage() {
  const {
    t
  } = useLanguage();
  const sections = [{
    icon: Camera,
    title: t('evidence.screenshots.title'),
    steps: [t('evidence.screenshots.step1'), t('evidence.screenshots.step2'), t('evidence.screenshots.step3'), t('evidence.screenshots.step4')]
  }, {
    icon: Mail,
    title: t('evidence.email.title'),
    steps: [t('evidence.email.step1'), t('evidence.email.step2'), t('evidence.email.step3'), t('evidence.email.step4')]
  }, {
    icon: FileText,
    title: t('evidence.transaction.title'),
    steps: [t('evidence.transaction.step1'), t('evidence.transaction.step2'), t('evidence.transaction.step3'), t('evidence.transaction.step4')]
  }, {
    icon: Shield,
    title: t('evidence.conversations.title'),
    steps: [t('evidence.conversations.step1'), t('evidence.conversations.step2'), t('evidence.conversations.step3'), t('evidence.conversations.step4')]
  }];
  return <div className="container mx-auto px-4 py-12 max-w-5xl" data-id="element-814">
      <SEO title={t('seo.evidence.title')} description={t('seo.evidence.desc')} data-id="element-815" />
      <div className="text-center mb-12 animate-fade-in" data-id="element-816">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-info/10 rounded-2xl mb-6" data-id="element-817">
          <Shield className="h-8 w-8 text-info" data-id="element-818" />
        </div>
        <h1 className="text-4xl font-bold mb-4" data-id="element-819">{t('evidence.title')}</h1>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto" data-id="element-820">
          {t('evidence.subtitle')}
        </p>
      </div>

      <div className="mb-12" data-id="element-821">
        <WarningBanner message={t('evidence.warning')} variant="warning" dismissible={false} data-id="element-822" />
      </div>

      <div className="space-y-8" data-id="element-823">
        {sections.map((section, index) => {
        const Icon = section.icon;
        return <Card key={index} className="animate-slide-up" style={{
          animationDelay: `${index * 100}ms`
        }} data-id="element-824">
              <div className="flex items-start space-x-4 mb-6" data-id="element-825">
                <div className="p-3 bg-primary/5 rounded-xl" data-id="element-826">
                  <Icon className="h-6 w-6 text-primary" data-id="element-827" />
                </div>
                <div data-id="element-828">
                  <h2 className="text-2xl font-bold" data-id="element-829">{section.title}</h2>
                </div>
              </div>
              <ol className="space-y-3 ml-16" data-id="element-830">
                {section.steps.map((step, stepIndex) => <li key={stepIndex} className="flex items-start" data-id="element-831">
                    <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary text-white flex items-center justify-center text-sm font-semibold mr-3" data-id="element-832">
                      {stepIndex + 1}
                    </span>
                    <span className="text-gray-700 leading-relaxed pt-0.5" data-id="element-833">
                      {step}
                    </span>
                  </li>)}
              </ol>
            </Card>;
      })}
      </div>

      {/* Data Safety Tips */}
      <Card className="mt-12 bg-blue-50 border-blue-100" data-id="element-834">
        <div className="flex items-start space-x-4" data-id="element-835">
          <AlertCircle className="h-6 w-6 text-info flex-shrink-0 mt-1" data-id="element-836" />
          <div data-id="element-837">
            <h3 className="text-xl font-bold mb-3 text-blue-900" data-id="element-838">
              {t('evidence.anonymization.title')}
            </h3>
            <ul className="space-y-2 text-blue-800" data-id="element-839">
              <li className="flex items-start" data-id="element-840">
                <span className="mr-2" data-id="element-841">•</span>
                <span data-id="element-842">{t('evidence.anonymization.tip1')}</span>
              </li>
              <li className="flex items-start" data-id="element-843">
                <span className="mr-2" data-id="element-844">•</span>
                <span data-id="element-845">{t('evidence.anonymization.tip2')}</span>
              </li>
              <li className="flex items-start" data-id="element-846">
                <span className="mr-2" data-id="element-847">•</span>
                <span data-id="element-848">{t('evidence.anonymization.tip3')}</span>
              </li>
              <li className="flex items-start" data-id="element-849">
                <span className="mr-2" data-id="element-850">•</span>
                <span data-id="element-851">{t('evidence.anonymization.tip4')}</span>
              </li>
            </ul>
          </div>
        </div>
      </Card>
    </div>;
}